/**
 * Pretty-print for debug views: 2-space indent, safe for circular refs,
 * and unwraps string values that contain JSON so they indent with the rest.
 */
export function formatJsonPretty(value: unknown, space: string | number = 2): string {
  const seen = new WeakSet<object>()
  try {
    return JSON.stringify(
      value,
      (_key, val) => {
        if (typeof val === 'bigint') return val.toString()
        if (typeof val === 'object' && val !== null) {
          if (seen.has(val as object)) return '[Circular]'
          seen.add(val as object)
        }
        if (typeof val === 'string') {
          const t = val.trim()
          if (t.length >= 2) {
            const looksLikeObject = t.startsWith('{') && t.endsWith('}')
            const looksLikeArray = t.startsWith('[') && t.endsWith(']')
            if (looksLikeObject || looksLikeArray) {
              try {
                return JSON.parse(val) as unknown
              } catch {
                /* keep original string */
              }
            }
          }
        }
        return val
      },
      space
    )
  } catch (e) {
    return `[Error serializing JSON: ${e instanceof Error ? e.message : String(e)}]`
  }
}
